function CircularProgress({ percent }) {
  const strokeWidth = 8;
  const size = 60;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  let color = "stroke-red-500";
  if (percent <= 50) color = "stroke-green-500";
  else if (percent <= 90) color = "stroke-orange-400";

  const offset = circumference - (percent / 100) * circumference;

  return (
    <svg width={size} height={size} className="mr-3">
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="#e5e7eb"
        strokeWidth={strokeWidth}
        fill="transparent"
      ></circle>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        className={color}
        strokeWidth={strokeWidth}
        fill="transparent"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      ></circle>
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        className="text-sm font-black fill-gray-700"
      >
        {percent}%
      </text>
    </svg>
  );
}

export default CircularProgress;
